export default __webpack_public_path__ + "static/media/lake.23d5f7b5.mp3";